<ng-container *ngIf="!isLoadingData; else loader">
  <form id="profile" [formGroup]="roleForm" [class.form-portrait-override]="displayService.isPortrait">
    <mat-list role="list">
      <mat-list-item *ngFor="let i of activePermissions; index as m" class="width" formGroupName="{{ i.accountUid }}">
        <ng-container *ngIf="activeAccountPermission?.edit; else nonEditable">
          <div class="width d-flex">
            <ng-container *ngIf="i.uid ? i.enabled : !i.enabled; else showError">
              <div class="flex-grow col-9">
                {{ i.accountTitle }}
              </div>
              <mat-form-field appearance="outline" class="col-3">
                <mat-select
                  [value]="i.uid"
                  formControlName="uid"
                  panelClass="mat-select-override"
                  [placeholder]="'restoreUser.placeholder' | translate"
                  track="Users, restore_user_select_role"
                >
                  <mat-option *ngIf="i.accountUid !== accountUid">{{
                    'restoreUser.placeholder' | translate
                  }}</mat-option>
                  <mat-option *ngFor="let option of i.options" [value]="option.uid">{{ option.title }}</mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>

            <ng-template #showError>
              <div class="flex-grow col-3">
                <div class="accountTitle" matTooltip="{{ i.accountTitle }}">{{ i.accountTitle }}</div>
              </div>
              <mat-error class="col-5">
                {{
                  (i.uid
                    ? 'restoreUser.accountError'
                    : i.accountUid !== accountUid
                    ? 'restoreUser.roleError'
                    : 'restoreUser.defaultAccountError'
                  ) | translate
                }}
              </mat-error>
              <mat-form-field appearance="outline" class="col-3">
                <mat-select
                  [value]="i.uid"
                  formControlName="uid"
                  panelClass="mat-select-override"
                  [placeholder]="'restoreUser.placeholder' | translate"
                  track="Users, restore_user_select_role"
                >
                  <mat-option *ngIf="i.accountUid !== accountUid">{{
                    'restoreUser.placeholder' | translate
                  }}</mat-option>
                  <mat-option *ngFor="let option of i.options" [value]="option.uid">{{ option.title }}</mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
            <mat-divider></mat-divider>
          </div>
        </ng-container>

        <ng-template #nonEditable>
          <div class="width d-flex grayed" appearance="outline">
            <div class="flex-grow">
              {{ i.accountTitle }}
            </div>
            <div class="col-3">
              <p class="disabledTitle">{{ i.title }}</p>
            </div>
            <div class="col-5">{{ 'restoreUser.noEditPermission' | translate }}</div>
            <mat-divider></mat-divider>
          </div>
        </ng-template>
      </mat-list-item>
    </mat-list>
  </form>
</ng-container>

<ng-template #loader>
  <ng-container *ngFor="let i of [].constructor(3)">
    <ngx-skeleton-loader [theme]="{ width: '100%', height: '50px', marginTop: '1.34375em' }"></ngx-skeleton-loader>
    <mat-divider></mat-divider>
  </ng-container>
</ng-template>
